import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { ProcessDefinitionProps } from "../../types/processDefinition";

export interface ProcessDefinitionsState {
  definitions: ProcessDefinitionProps[];
  isModalOpen: boolean;
  editDefinition: ProcessDefinitionProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: ProcessDefinitionsState = {
  definitions: [],
  isModalOpen: false,
  editDefinition: null,
  loading: false,
  error: null,
};

export const fetchProcessDefinitions = createAsyncThunk(
  "processDefinitions/fetchList",
  async (req: { all?: boolean } = {}) => {
    let response: any;
    await GET(`/v1/process-definitions`, { ...req })
      .then((res: any) => { response = res; })
      .catch((err) => { response = err; });
    return response;
  }
);

export const processDefinitionsSlice = createSlice({
  name: "processDefinitions",
  initialState,
  reducers: {
    toggleProcessDefinitionModal: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setEditProcessDefinition: (state, action: PayloadAction<ProcessDefinitionProps | null>) => {
      state.editDefinition = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProcessDefinitions.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchProcessDefinitions.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload?.data?.status === "success") {
        state.definitions = action.payload.data.data;
        state.error = null;
      } else {
        state.definitions = [];
        state.error = action?.payload?.data?.message || "Something went wrong.";
      }
    });
    builder.addCase(fetchProcessDefinitions.rejected, (state, action: any) => {
      state.definitions = [];
      state.loading = false;
      state.error = action?.payload?.data?.message || "Something went wrong.";
    });
  },
});

export const { toggleProcessDefinitionModal, setEditProcessDefinition } = processDefinitionsSlice.actions;

export const getProcessDefinitions = (state: RootState) => state.processDefinitions.definitions;
export const getProcessDefinitionsLoading = (state: RootState) => state.processDefinitions.loading;
export const getIsProcessDefinitionModalOpen = (state: RootState) => state.processDefinitions.isModalOpen;
export const getEditProcessDefinition = (state: RootState) => state.processDefinitions.editDefinition;

export default processDefinitionsSlice.reducer;
